import { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const AdminLogin = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Check password
    if (password === 'apple') {
      // Store authentication in sessionStorage
      sessionStorage.setItem('adminAuth', 'true');
      onLoginSuccess();
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  return (
    <section className="admin-login" id="admin-login">
      <Container>
        <Row className="justify-content-center">
          <Col lg={6} md={8}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <div className="admin-login-container">
                    <h2>Admin Access</h2>
                    <p className="admin-login-subtitle">Enter password to access admin console</p>
                    
                    <Form onSubmit={handleSubmit}>
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="password"
                          placeholder="Enter admin password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          className="admin-password-input"
                          autoFocus
                          required
                        />
                      </Form.Group>
                      
                      {error && (
                        <div className="admin-error-message">
                          {error}
                        </div>
                      )}
                      
                      <Button type="submit" className="admin-login-btn">
                        Access Admin Console
                      </Button>
                    </Form>
                  </div>
                </div>
              }
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
